import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { baseurl } from '../utility/helper';
import '../assets/css/NewsEvent.css';

const NewsEventForm = () => {
    const [images, setImages] = useState([]);
    const roleid = parseInt(sessionStorage.getItem("userroleId"));
    const [images2, setImages2] = useState([]);
    const { id } = useParams();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        title: '',
        short_desc: '',
        long_desc: '',
        start_date: '',
        end_date: '',
        created_by: '',
        visible: true,
        status: '',
    });

    useEffect(() => {
        if (id) {
            const fetchEventData = async () => {
                try {
                    const token = sessionStorage.getItem("token");
                    const response = await axios.get(`${baseurl}/admin/eventlist/${id}`, {
                        headers: {
                            'Authorization': `${token}`,
                            'Content-Type': 'application/json'
                        },
                    });
                    const convertToLocalDate = (date) => {
                        const localDate = new Date(date);
                        localDate.setMinutes(localDate.getMinutes() - localDate.getTimezoneOffset());
                        return localDate.toISOString().split('T')[0];
                    };
                    const eventData = response.data[0]; // Assuming only one event is returned
                    setFormData({
                        ...eventData,
                        start_date: convertToLocalDate(eventData.start_date),
                        end_date: convertToLocalDate(eventData.end_date),
                    });
                    // Set image preview from Base64 data
                    if (eventData.main_image) {
                        setImages([eventData.main_image]); // Base64 image from API
                    }
                    // Set additional images array
                    if (eventData.event_images) {
                        setImages2(eventData.event_images); // Multiple images
                    }
                } catch (error) {
                    console.error('Error fetching event data:', error);
                }
            };
            fetchEventData();
        }
    }, [id]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    const handleImageUpload = (e) => {
        const files = Array.from(e.target.files);
        
        if (files.length > 1) {
            Swal.fire("Error", "You can upload only one main image.", "error");
            return;
        }
    
        const file = files[0];
    
        if (file.size > 500 * 1024) {
            Swal.fire("Error", "Main image must be less than 500KB!", "error");
            return;
        }
    
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setImages([reader.result]); // Store Base64 string for the main image
        };
    };
    
    const handleImage2Upload = (e) => {
        const files = Array.from(e.target.files);
        
        if (images2.length + files.length > 10) {
            Swal.fire("Error", "You can upload a maximum of 10 images.", "error");
            return;
        }
    
        const validImages = files.filter(file => {
            if (file.size > 500 * 1024) {
                Swal.fire("Error", `Image ${file.name} must be less than 500KB!`, "error");
                return false;
            }
            return true;
        });
    
        const newImages = validImages.map(file => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            return new Promise((resolve) => {
                reader.onload = () => {
                    resolve(reader.result); // Resolve with the Base64 string
                };
            });
        });
    
        Promise.all(newImages).then((base64Images) => {
            setImages2((prevImages) => [...prevImages, ...base64Images]);
        });
    };
    

    const removeImage = () => {
        setImages([]);
    };

    const removeImage2 = (index) => {
        setImages2(images2.filter((_, i) => i !== index));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const adminId = sessionStorage.getItem("adminId");
        const cleanedFormData = {
            ...formData,
            adminId: adminId,
            start_date: formData.start_date || null,
            end_date: formData.end_date || null,
            visible: formData.visible ? true : false,
            images: images[0], // Send main image as a Base64 string
        };
        
        const formDataToSend = new FormData();
        Object.keys(cleanedFormData).forEach((key) => {
            formDataToSend.append(key, cleanedFormData[key]);
        });
    
        // Append the main image
        if (images.length > 0) {
            formDataToSend.append("images", images[0]);
        }
        // Append all additional images to FormData
        images2.forEach((image) => {
            formDataToSend.append("images2", image);
        });
        console.log('Form Data to Send:', Array.from(formDataToSend.entries())); // Log the FormData entries

        try {
            const token = sessionStorage.getItem("token");
            const url = id ? `${baseurl}/admin/eventlist/${id}` : `${baseurl}/admin/eventlist`;
            const method = id ? "put" : "post";
    
            const response = await axios({
                method,
                url,
                data: formDataToSend,
                headers: {
                    'Authorization': `${token}`,
                    'Content-Type': 'multipart/form-data'
                },
            });
    
            console.log('Form data successfully sent to the database:', response.data);
            Swal.fire({
                title: 'Success!',
                text: 'News & Event Details submitted successfully!',
                icon: 'success',
                timer: 5000,
                timerProgressBar: true,
                willClose: () => {
                    setTimeout(() => {
                        navigate("/admin/Newseventlist");
                    }, 500);
                }
            });
        } catch (error) {
            console.error('Error sending form data to the database:', error);
        }
    };

    const handleDelete = (id) => {
        const token = sessionStorage.getItem("token"); // Retrieve token from local storage (or another storage method)
    
        fetch(`${baseurl}/admin/eventlist/${id}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `${token}`, // Pass the token in the Authorization header
            'Content-Type': 'application/json' // Ensure proper content type
          }
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error('Failed to delete event');
            }
            return response.json();
          })
          .then((response) => {
            console.log('Form data successfully sent to the database:', response.data);
            // Show SweetAlert after successful submission
            Swal.fire({
              title: 'Success!',
              text: 'News & Event Deleted successfully!',
              icon: 'success',
              timer: 5000, // Show for 5 seconds
              timerProgressBar: true,
              willClose: () => {
                window.history.back()
              }
            });
          })
          .catch((error) => console.error('Error deleting event:', error));
      };
    return (
        <div className="container mt-4">
            <button className="cl-back-btn " onClick={() => window.history.back()}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M10 3L5 8l5 5"/></svg>
                Back
            </button>
            {roleid === 1 && (
            <button onClick={() => handleDelete(id)} className="btn btn-danger btn-sm" style={{ float : 'right'}}>
                Delete
            </button>
            )}
            <form onSubmit={handleSubmit} className="card p-4 shadow">
                <center><h2 className="mb-4">{id ? 'Edit News Event' : 'Create News Event'}</h2></center>
                <hr />
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group mb-3">
                            <label>Title:</label>
                            <input
                                type="text"
                                name="title"
                                className="form-control"
                                value={formData.title}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group mb-3">
                            <label>Short Description:</label>
                            <textarea
                                name="short_desc"
                                className="form-control"
                                value={formData.short_desc}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group mb-3">
                            <label>Start Date:</label>
                            <input
                                type="date"
                                name="start_date"
                                className="form-control"
                                value={formData.start_date}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group mb-3">
                            <label>Status:</label>
                            <select
                                name="status"
                                className="form-control"
                                value={formData.status}
                                onChange={handleChange}
                            >
                                <option value="draft">Draft</option>
                                <option value="published">Published</option>
                                <option value="archived">Archived</option>
                            </select>
                        </div>
                        <div className="form-group mb-3">
                            <label>Upload Additional Images (Max 10):</label>
                            <input type="file" className="form-control" onChange={handleImage2Upload} multiple accept="image/*" />
                        </div>
                        <div className="image-preview d-flex flex-wrap mt-3">
                            {images2.map((img, index) => (
                                <div key={index} className="preview-container position-relative me-2">
                                    <img src={img} alt="preview" className="img-thumbnail" style={{ width: "100px", height: "100px", objectFit: "cover" }} />
                                    <button type="button" className="btn btn-danger btn-sm position-absolute top-0 end-0" onClick={() => removeImage2(index)}>❌</button>
                                </div>
                            ))}
                        </div>
                        
                        
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-3">
                            <label>Long Description:</label>
                            <textarea
                                name="long_desc"
                                className="form-control"
                                value={formData.long_desc}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group mb-3">
                            <label>Created By:</label>
                            <input
                                type="text"
                                name="created_by"
                                className="form-control"
                                value={formData.created_by}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group mb-3">
                            <label>End Date:</label>
                            <input
                                type="date"
                                name="end_date"
                                className="form-control"
                                value={formData.end_date}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className='row col-md-12' style={{paddingLeft:0}}>
                        <div className="form-group mb-3 col-md-8">
                            <label>Upload Main Image:</label>
                            <input
                                type="file"
                                name="images"
                                className="form-control"
                                onChange={handleImageUpload}
                                accept="image/*"
                            />
                        </div>
                        <div className="image-preview d-flex flex-wrap mt-3 col-md-4">
                            {images.length > 0 && (
                                <div className="preview-container position-relative me-2">
                                    <img
                                        src={images[0]}
                                        alt="main preview"
                                        className="img-thumbnail"
                                        style={{ width: "100px", height: "100px", objectFit: "cover" }}
                                    />
                                    <button
                                        type="button"
                                        className="btn btn-danger btn-sm position-absolute top-0 end-0"
                                        onClick={removeImage}
                                    >
                                        ❌
                                    </button>
                                </div>
                            )}
                        </div>
                        </div>
                        <div className="form-group mb-3">
                            <label>Visible:</label>
                            <input
                                type="checkbox"
                                name="visible"
                                className="form-check-input ms-2"
                                checked={formData.visible}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                </div>
                <div className="text-center mt-3">
                    <button type="submit" style={{borderRadius:'8px'}}>{id ? 'Update Event' : 'Create Event'}</button>
                </div>
            </form>
        </div>
    );
};

export default NewsEventForm;